import getAppConfiguration from "../../appConfiguration"

const appConfig = getAppConfiguration();


export const COMPRESSTION_OPTION = {
	auto: 'auto',
}


export const OUTPUT_FORMAT_OPTION = {
	auto: 'auto',
}


export default class PathUrlGenerator {

	constructor(url) {
		this.url = url;
		this.width = null;
		this.height = null;
		this.quality = appConfig.imageQuality;
		this.outputFormat= 'auto';
		this.compress = null;
		this.ImageFormat = null;
		this.otherOptions = null;
	}

	setWidth(width) {
		this.width = width;
		return this;
	}

	setHeight(height) {
		this.height= height;
		return this;
	}

	setQuality(quality) {
		this.quality = quality;
		return this;
	}

	setOutputFormat(format) {
		this.outputFormat = format;
		return this;
	}

	setOtherOptions(otherOptions) {
		this.otherOptions = otherOptions;
		return this;
	}

	build() {
		return this.url;
	}
}